import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppPrivacyComponent } from './pages/app-privacy/app-privacy.component';
import { AppSupportComponent } from './pages/app-support/app-support.component';
import { InvisibleComponent } from './pages/invisible/invisible.component';
import { AuthGuard } from './shared/services/guards/auth.guard';

const routes: Routes = [

  { path: '', redirectTo: 'auth', pathMatch: 'full' },
  {
    path: 'auth',
    loadChildren: () => import('./routes/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'main',
    loadChildren: () => import('./routes/main/main.module').then(m => m.MainModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'invisible',
    component: InvisibleComponent
  },
  // {
  //   path: 'app-support',
  //   component: AppSupportComponent
  // },
  // {
  //   path: 'app-privacy/:t',
  //   component: AppPrivacyComponent
  // },
  { path: '**', redirectTo: 'auth' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
